import { InputNumber } from "@/components/InputNumber";
import { selectStandardProps } from "@/utils/componentUtils";
import { validations } from "@/utils/validationUtils";
import { Checkbox, Col, Form, Row, Select } from "antd";
import { useTranslation } from "react-i18next";
import { rowGutter } from "../../../../../../../common/constants";
import { GapDuration } from "../../../../../../calculator/calcs/vehicle/enums";
import { StandardVehicleInsuranceFormPart } from "./StandardVehicleInsuranceFormPart";

const colSpan = 4;

type Props = {
  index: number;
  formNameDataPrefix: (string | number)[];
};

export const GapInsuranceFormPart = ({ formNameDataPrefix, index }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <Row gutter={rowGutter}>
        <Col span={colSpan}>
          <Form.Item
            name={[...formNameDataPrefix, "duration"]}
            label={t("calc.vehicle.enums.gapDuration._label")}
            rules={[validations.notNull]}
          >
            <Select
              {...selectStandardProps}
              options={Object.keys(GapDuration).map((duration) => ({
                value: duration,
                label: t("calc.vehicle.enums.gapDuration." + duration),
              }))}
            />
          </Form.Item>
        </Col>

        <Col span={colSpan}>
          <Form.Item
            name={[...formNameDataPrefix, "buyingPrice"]}
            label={t("contract.attrs.insurances.insuranceData.buyingPrice")}
            rules={[validations.minNumber(1)]}
          >
            <InputNumber type="decimal" addon="euro" />
          </Form.Item>
        </Col>

        <StandardVehicleInsuranceFormPart formNameDataPrefix={formNameDataPrefix} index={index} />

        <Col span={colSpan}>
          <Form.Item
            name={[...formNameDataPrefix, "complicityReinsurance"]}
            valuePropName="checked"
            rules={[validations.none]}
            initialValue={false}
            className="form-item-without-label"
          >
            <Checkbox>{t("contract.attrs.insurances.insuranceData.complicityReinsurance")}</Checkbox>
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};
